/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import {
  Box,
  Link,
  Drawer,
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MastersIcon from '../../../media/layers.png';
import home from '../../../media/home.png'
import mis from '../../../media/mis.png';

// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import './nav.css';
//
import Transactions from './Transactions';
import Sales from './Sales';
import MIS from './MIS';
import Customer from './Customer';
import Masters from './Masters';
import MastersData from './MastersData';
import logoImage from '../../../media/login/logo.png';
import logo from '../../../media/BMS-logo1.png';

// ----------------------------------------------------------------------

const NAV_WIDTH = 250;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.2),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  opennav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ opennav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (!opennav) {
      onCloseNav();
    }
  }, [pathname]);


  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ mb: 5, m: 1 }}>
        <Link underline="none">
          <StyledAccount>
            <button
              onClick={() => {
                console.log('Clicked on the logo');
                if(sessionStorage.getItem('userRole') === 'Admin' || sessionStorage.getItem('userRole') === 'Sales') navigate('/dashboard/home');
              }}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={logoImage}
                style={{
                  objectFit: 'contain',
                  maxWidth: '70%',
                  borderRadius: '10px',
                }}
                alt="brand logo"
              />
            </button>
          </StyledAccount>
        </Link>
      </Box>

      {(sessionStorage.getItem('userRole') === 'Sales' || sessionStorage.getItem('userRole') === 'Admin') && (
        <Stack
          direction="row"
          alignItems="center"
          p={1}
          sx={{
            bgcolor: location.pathname === "/dashboard/home" ? "action.selected" : "inherit",
            cursor: "pointer",
            pl: 2,

          }}
          onClick={() => navigate("/dashboard/home")} // Change the route accordingly
        >
          <IconButton aria-label="icon">
            <img src={home} alt="M" style={{ width: 25, height: 25 }} />
          </IconButton>
          <Typography sx={{
            color: 'white',

          }}>Dashboard</Typography>
        </Stack>
      )
      }


      {/* {sessionStorage.getItem('userRole') === 'Admin' && sessionStorage.getItem('IsHeadOffice') === 'Y' && ( */}
      {sessionStorage.getItem('userRole') === 'Admin' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Manage
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Transactions} />
          </AccordionDetails>
        </Accordion>
      )}

      {sessionStorage.getItem('userRole') === 'Sales' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Sales
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Sales} />
          </AccordionDetails>
        </Accordion>
      )}

      {(sessionStorage.getItem('userRole') === 'Sales' || sessionStorage.getItem('userRole') === 'Admin') && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={mis} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                MIS
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={MIS} />
          </AccordionDetails>
        </Accordion>
      )}

      {sessionStorage.getItem('userRole') === 'Customer' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Bookings
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Customer} />
          </AccordionDetails>
        </Accordion>
      )}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: opennav ? NAV_WIDTH : 0 },
      }}
    >
      {isDesktop ? (
        <Drawer
          open={opennav}
          variant={opennav ? 'persistent' : 'temporary'}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              // bgcolor: '#091057'
              background: ' #8EACCD',
            },
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={opennav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              // bgcolor: '#091057'
              background: ' #8EACCD',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
